export default __webpack_public_path__ + "static/media/profile-awla.e57a2282.png";